import React from 'react';
import { IDataBox } from '../DataBox.types';
import { Value } from '../DataBox.styles';

export default function DataBoxValue({ children, testId = 'data-box-item' }: IDataBox) {
  return <Value data-testid={testId}>{children}</Value>;
}
